import React from 'react';
import './units.scss';

const Units = props => {
    return (
        <div className="filter-units">
            <h2 className="filter-units__heading">Här kan du inkludera eller exkludera specifika butiker.</h2>
            <label className="filter-units__label" htmlFor="add-unit">DelfiNr eller butikens namn</label>
            <input type="text" id="add-unit" className="filter-units__add-field" />
            <div className="filter-units__controls">
                <button type="button" className="form__button">Inkludera butiken</button>
                <button type="button" className="form__button">Exkludera butiken</button>
            </div>

            <ul className="filter-units__list">
                <li>
                    <span className="filter-units__list-item-heading">Ica Maxi Uppsala</span>
                    <span>Inkluderad</span>
                    <button className="filter-units__list-item-delete" type="button"></button>
                </li>
                <li>
                    <span className="filter-units__list-item-heading">Coop Forum Uppsala</span>
                    <span>Exkluderad</span>
                    <button className="filter-units__list-item-delete" type="button"></button>
                </li>
                <li>
                    <span className="filter-units__list-item-heading">Willy:s Uppsala</span>
                    <span>Exkluderad</span>
                    <button className="filter-units__list-item-delete" type="button"></button>
                </li>
            </ul>
        </div>
    );
};

export default Units;